import React from 'react'
import { Box, Typography, useTheme, Tabs, Tab, Button } from "@mui/material"
import subtareasIcon from '../../../../assets/subtareasIcon.png'
import cascoIcon from '../../../../assets/helmet.png'
import paqueteIcon from '../../../../assets/paquete.png'
import imagenIcon from '../../../../assets/imagenIcon.png'
import { useState, useEffect, useCallback, useMemo } from "react"
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { useTaskContext } from "../../../../shared/context/taskContext"
import { useOt } from "../../../../shared/context/otContext"
import moment from "moment"

//Componentes
import SsomaReview from "./ssomaReview"
import SubtaskReview from "./subtaskReview"
import InsumoReview from "./insumoReview"
import AttachReview from "./attachReview"



const OtReviewManager = () => {
    const theme = useTheme()

    const { hash_code_task, getTaskByHash, setHashCodeTask, taskByHash, startTask, finishTask, loadingStartTask, loadingFinishTask, valueOtReview, setValueOtReview } = useTaskContext()
    const { ot } = useOt()


    // Memoizar la función handleChange
    const handleChange = useCallback((event, newValue) => {
        setValueOtReview(newValue)
    }, [])

    useEffect(() => {
        console.log(taskByHash)
    }, [taskByHash])







    // Memoizar el componente renderizado
    const renderComponent = useMemo(() => {
        switch (valueOtReview) {
            case 0:
                return taskByHash?.required_ssoma_document ? <SsomaReview /> : null
            case 1:
                return <SubtaskReview />
            case 2:
                return <InsumoReview />
            case 3:
                return <AttachReview />
            default:
                return null
        }
    }, [valueOtReview, taskByHash])

    // Memoizar las tabs
    const renderTabs = useMemo(() => {
        const tabs = []

        if (taskByHash?.required_ssoma_document) {
            tabs.push(
                <Tab
                    key="ssoma"
                    value={0}
                    icon={<img src={cascoIcon} alt="SSOMA" style={{ filter: theme.palette.mode === 'light' ? 'invert(1)' : 'none', width: '25px', height: '25px' }} />}
                    label="SSOMA"
                />
            )
        }

        tabs.push(
            <Tab
                key="subtask"
                value={1}
                icon={<img src={subtareasIcon} alt="subtask" style={{ filter: theme.palette.mode === 'light' ? 'invert(1)' : 'none', width: '25px', height: '25px', opacity: taskByHash?.required_ssoma_document && !taskByHash?.ssoma_validate ? 0.5 : 1 }} />}
                label="Subtareas"
                disabled={taskByHash?.required_ssoma_document && !taskByHash?.ssoma_validate}
            />
        )


        tabs.push(
            <Tab
                key="insumo"
                value={2}
                icon={<img src={paqueteIcon} alt="paquete" style={{ filter: theme.palette.mode === 'light' ? 'invert(1)' : 'none', width: '25px', height: '25px', opacity: taskByHash?.required_ssoma_document && !taskByHash?.ssoma_validate ? 0.5 : 1 }} />}
                label="Insumo"
                disabled={taskByHash?.required_ssoma_document && !taskByHash?.ssoma_validate}
            />
        )


        tabs.push(
            <Tab
                key="attach"
                value={3}
                icon={<img src={imagenIcon} alt="imagenAdjunta" style={{ filter: theme.palette.mode === 'light' ? 'invert(1)' : 'none', width: '25px', height: '25px', opacity: taskByHash?.required_ssoma_document && !taskByHash?.ssoma_validate ? 0.5 : 1 }} />}
                disabled={taskByHash?.required_ssoma_document && !taskByHash?.ssoma_validate}
                label="Adjunto"
            />
        )

        return tabs
    }, [taskByHash, theme.palette.mode])

    // Memoizar el contenido del estado in_process
    const inProcessContent = useMemo(() => {
        if (ot?.status?.name === 'in_process') {
            return (
                <>
                    {
                        !taskByHash?.datetime_start ?
                            <Button variant="outlined" color="primary" startIcon={<PlayCircleOutlineIcon />}
                                disabled={taskByHash?.required_ssoma_document && !taskByHash?.ssoma_validate}
                                onClick={() => startTask(hash_code_task)}>
                                Iniciar tarea
                            </Button>
                            :
                            !taskByHash?.datetime_end &&
                            <Button variant="outlined" color="primary" startIcon={<PlayCircleOutlineIcon />}
                                disabled={taskByHash?.required_ssoma_document && !taskByHash?.ssoma_validate}
                                onClick={() => finishTask(hash_code_task)}>
                                Finalizar tarea
                            </Button>
                    }
                </>

            )
        }
        return null
    }, [ot?.status?.name, taskByHash, hash_code_task, startTask, finishTask])



    //cronometro
    const [cronometro, setCronometro] = useState({ hours: 0, minutes: 0, seconds: 0 })

    useEffect(() => {
        if (taskByHash?.datetime_start && !taskByHash?.datetime_end) {
            // Calcular tiempo inicial desde el datetime_start hasta ahora
            const startTime = new Date(taskByHash.datetime_start).getTime();

            // Actualizar inmediatamente para mostrar el tiempo correcto al cargar
            const updateElapsedTime = () => {
                const now = new Date().getTime();
                const elapsedMilliseconds = now - startTime;
                const elapsedSeconds = Math.floor(elapsedMilliseconds / 1000);

                const hours = Math.floor(elapsedSeconds / 3600);
                const minutes = Math.floor((elapsedSeconds % 3600) / 60);
                const seconds = elapsedSeconds % 60;

                // Formato de 24 horas con ceros a la izquierda
                const formattedHours = hours.toString().padStart(2, '0');
                const formattedMinutes = minutes.toString().padStart(2, '0');
                const formattedSeconds = seconds.toString().padStart(2, '0');

                setCronometro({
                    hours: formattedHours,
                    minutes: formattedMinutes,
                    seconds: formattedSeconds
                });
            };

            // Actualizar inmediatamente
            updateElapsedTime();

            // Configurar intervalo para actualizar cada segundo
            const interval = setInterval(updateElapsedTime, 1000);

            return () => clearInterval(interval);
        }
    }, [taskByHash?.datetime_start, taskByHash?.datetime_end]);


    // renderizar el cronometro
    const renderCronometro = useMemo(() => {
        return (
            <>
                {taskByHash?.datetime_start && !taskByHash?.datetime_end ? <Box>
                    <Typography>{`${cronometro.hours}:${cronometro.minutes}:${cronometro.seconds}`}</Typography>
                </Box> : null}
            </>
        )
    }, [cronometro, taskByHash?.datetime_start, taskByHash?.datetime_end])


    const calcularTiempo = useMemo(() => {
        if (taskByHash?.datetime_start && taskByHash?.datetime_end) {
            const startTime = new Date(taskByHash.datetime_start).getTime();
            const endTime = new Date(taskByHash.datetime_end).getTime();
            const elapsedMilliseconds = endTime - startTime;
            const elapsedSeconds = Math.floor(elapsedMilliseconds / 1000);

            const hours = Math.floor(elapsedSeconds / 3600);
            const minutes = Math.floor((elapsedSeconds % 3600) / 60);
            const seconds = elapsedSeconds % 60;

            const formattedHours = hours.toString().padStart(2, '0');
            const formattedMinutes = minutes.toString().padStart(2, '0');
            const formattedSeconds = seconds.toString().padStart(2, '0');

            return (
                <Typography>{`${formattedHours}:${formattedMinutes}:${formattedSeconds}`}</Typography>
            )
        }
        return null;
    }, [taskByHash?.datetime_start, taskByHash?.datetime_end])

    // Memoizar el contenido del estado no in_process
    const notInProcessContent = useMemo(() => {
        if (taskByHash?.datetime_start && taskByHash?.datetime_end) {
            return (
                <Box sx={{
                    display: 'flex',
                    gap: 2,
                    flexWrap: 'wrap',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%'
                }}>

                    {calcularTiempo}
                    <Box sx={{
                        display: 'flex',
                        gap: 2,
                        flexWrap: 'nowrap',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <Box sx={{
                            width: '120px',
                            height: 'auto',
                            background: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.main})`,
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            padding: '4px 12px',
                            transition: 'transform 0.2s ease',
                            '&:hover': {
                                transform: 'translateY(-3px)',
                                boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)'
                            }
                        }}>
                            <Typography variant="caption" sx={{
                                color: theme.palette.primary.contrastText,
                                opacity: 0.9,
                                fontWeight: 500,
                                display: 'block',
                                fontSize: '9px'
                            }}>
                                INICIO
                            </Typography>
                            <Typography variant="body2" sx={{
                                fontWeight: 'bold',
                                color: theme.palette.primary.contrastText,
                                fontSize: '12px',
                                lineHeight: 1.2
                            }}>
                                {moment(taskByHash?.datetime_start).format('DD/MM/YYYY hh:mm:ss A')}
                            </Typography>
                        </Box>

                        <Box sx={{
                            width: '120px',
                            height: 'auto',
                            background: `linear-gradient(135deg, ${theme.palette.primary.light}, ${theme.palette.primary.main})`,
                            borderRadius: '8px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                            padding: '4px 12px',
                            transition: 'transform 0.2s ease',
                            '&:hover': {
                                transform: 'translateY(-3px)',
                                boxShadow: '0 6px 10px rgba(0, 0, 0, 0.1)'
                            }
                        }}>
                            <Typography variant="caption" sx={{
                                color: theme.palette.primary.contrastText,
                                opacity: 0.9,
                                fontWeight: 500,
                                display: 'block',
                                fontSize: '9px'
                            }}>
                                FINALIZACIÓN
                            </Typography>
                            <Typography variant="body2" sx={{
                                fontWeight: 'bold',
                                color: theme.palette.primary.contrastText,
                                fontSize: '12px',
                                lineHeight: 1.2
                            }}>
                                {moment(taskByHash?.datetime_end).format('DD/MM/YYYY hh:mm:ss A')}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            )
        }
        return null
    }, [ot?.status?.name, taskByHash, theme.palette.primary])

    useEffect(() => {
        if (hash_code_task?.hash_code && (hash_code_task?.ot_id || ot?.id)) {
            getTaskByHash(
                hash_code_task.hash_code,
                hash_code_task.task_scheduled_id,
                hash_code_task.ot_id ?? ot?.id
            )
        }
    }, [hash_code_task.hash_code, hash_code_task.task_scheduled_id, hash_code_task.ot_id, ot?.id])

    useEffect(() => {
        if (taskByHash) {
            if (!taskByHash.required_ssoma_document && valueOtReview === 0) {
                setValueOtReview(1)
            }

            //si aun no se ha validado el ssoma no puede pasar a la siguiente pestaña
            if (taskByHash.required_ssoma_document && !taskByHash.ssoma_validate) {
                setValueOtReview(0)
            }
        }
    }, [taskByHash, valueOtReview])

    return (
        <>
            {!taskByHash ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', p: 4 }}>
                    <Typography variant="h6" color="text.secondary">
                        Cargando información de la tarea...
                    </Typography>
                </Box>
            ) : (
                <>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', p: 2 }}>
                        {renderCronometro}
                        {inProcessContent}
                        {notInProcessContent}
                    </Box>
                    <Box>
                        <Tabs value={valueOtReview} onChange={handleChange} variant="fullWidth" sx={{
                            backgroundColor: theme.palette.background.default,
                            '& .MuiTabs-indicator': {
                                backgroundColor: theme.palette.primary.main,
                                borderRadius: '16px'
                            }
                        }}>
                            {renderTabs}
                        </Tabs>
                        {renderComponent}
                    </Box>
                </>
            )}
        </>
    )
}

export default React.memo(OtReviewManager)